import { UseAuthContextType } from './auth.types';

export const OAUTH_CALLBACK_PARAMS = [
  'code',
  'state',
  'error',
  'error_description',
] as const;

export const SILENT_AUTH_RELOGIN_ERRORS = [
  'login_required',
  'invalid_grant',
  'missing_refresh_token',
  'consent_required',
  'interaction_required',
];

export const getDefaultUseAuthState = (
  opts: Partial<UseAuthContextType> = {},
): UseAuthContextType => ({
  isAuthenticated: false,
  isLoading: false,
  loginWithPopup: () => Promise.resolve(),
  loginWithRedirect: () => Promise.resolve(),
  getAccessTokenSilently: () => Promise.resolve(''),
  logout: () => Promise.resolve(),
  user: { name: 'default', picture: undefined, email: 'email@email.com' },
  ...opts,
});

export const hasOAuthCallbackParams = (params: URLSearchParams): boolean =>
  params.has('state') && (params.has('code') || params.has('error'));

export const getAuth0ErrorCode = (error: unknown): string | undefined =>
  typeof error === 'object' &&
  error !== null &&
  'error' in error &&
  typeof error.error === 'string'
    ? error.error
    : undefined;

export const isAuthCallbackReplayError = (error?: unknown): boolean =>
  getAuth0ErrorCode(error) === 'missing_transaction';
